(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ic-contact-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const status = document.querySelector('[data-ic-ct-status]');
      if (status) {
        status.scrollIntoView({ block: 'center', behavior: 'instant' });
        status.focus({ preventScroll: true });
      }
      document.querySelectorAll('[data-ic-ct-form]').forEach((form) => {
        if (form.dataset.icCtReady) return;
        form.dataset.icCtReady = '1';
        // feedback only, never blocks: Shopify's hCaptcha holds the first submit and re-submits the form itself
        const button = form.querySelector('.ic-ct-submit');
        const label = button && button.querySelector('[data-ic-ct-label]');
        const idle = label && label.textContent;
        let timer;
        form.addEventListener('submit', () => {
          if (!button) return;
          button.setAttribute('aria-busy', 'true');
          if (label && button.dataset.sending) label.textContent = button.dataset.sending;
          // still here after a while = the captcha was shown or closed, so give the button back
          clearTimeout(timer);
          timer = setTimeout(() => {
            button.removeAttribute('aria-busy');
            if (label) label.textContent = idle;
          }, 6000);
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ic-policy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // highlight the "On this page" link of the part being read
    const init = () => {
      document.querySelectorAll('.ic-pol').forEach((root) => {
        if (root.dataset.icPolReady || !('IntersectionObserver' in window)) return;
        root.dataset.icPolReady = '1';
        const links = [...root.querySelectorAll('[data-ic-pol-link]')];
        const parts = links.map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1)))).filter(Boolean);
        if (!parts.length) return;
        const visible = new Set();
        const mark = () => {
          const current = parts.find((part) => visible.has(part));
          links.forEach((link) => {
            if (current && link.hash === '#' + current.id) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        };
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => (entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target)));
          mark();
        }, { rootMargin: '-120px 0px -55% 0px' });
        parts.forEach((part) => io.observe(part));
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
